import { useWindowDimensions } from '@hooks';

const getValueForBGHeight = (width: number) => {
  if (width <= 640) return 92;
  if (width <= 1280) return 107;
  if (width < 1920) return 122;

  return 100;
};

export const useCalculateBackgroundForExperience = () => {
  const { width } = useWindowDimensions();
  return getValueForBGHeight(width);
};
